import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { compose } from 'recompose';

import { RouteInfo } from './router.types';

export interface RouterOutletProps {
  routes: RouteInfo[];
  redirect?: {
    from?: string;
    to: string;
  };
  match?: {
    path: string;
    url: string;
    isExact: boolean;
    params: { [key: string]: any };
  };
}

const RouterOutlet: React.FunctionComponent<RouterOutletProps> = ({ routes, redirect, match }) => (
  <Switch>
    {routes &&
      routes.map((route) => (
        <Route
          exact={route.exact}
          key={(match ? match.url : '') + route.path}
          path={(match ? match.url : '') + route.path}
          component={route.component}
        />
      ))}
    {redirect && redirect.to && <Redirect from={redirect.from} to={redirect.to} />}
  </Switch>
);

const ComposedRouterOutlet = compose<RouterOutletProps, any>()(RouterOutlet);

ComposedRouterOutlet.displayName = 'RouterOutlet';

export default ComposedRouterOutlet;
